import React, {Component} from 'react'
import PropTypes from 'prop-types'
import parseSearchQuery from "../../helpers/parseSearchQuery"


class SearchItemHeader extends Component {
    state = {
        barcode: ''
    }

    componentDidMount() {
        const {item} = this.props
        if(item) {
            this.setState({
                barcode: item
            })
        }
        this._parseFromSearchQuery()
    }

    _parseFromSearchQuery = () => {
        const {barcode} = parseSearchQuery()

        if (barcode && typeof barcode === 'string' && barcode.trim()) {
            this.props.onSubmit(barcode.trim())
        }
    }


    _handleSubmit = e => {
        e.preventDefault()

        const {barcode} = this.state
        const vBarcode = barcode.trim()

        if (!vBarcode) return false

        this.setState({
            barcode: ''
        }, () => {
            this.props.onSubmit(vBarcode)
        })
    }

    _handleChangeInput = e => {
        const {value} = e.target

        this.setState({
            barcode: value,
        })
    }

    render() {
        const {barcode} = this.state
        const {loading} = this.props


        return (
            <div className="SearchItemHeader">
                <form onSubmit={this._handleSubmit}>
                    <input type="text" value={barcode}
                           disabled={loading}
                           placeholder="Quét hoặc nhập QR tại đây"
                           onChange={this._handleChangeInput} className="form-control"/>
                </form>
            </div>
        )
    }
}

SearchItemHeader.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default SearchItemHeader
